var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoundUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9998 37.8333C45.8908 37.8333 50.6664 33.0577 50.6664 27.1667C50.6664 21.2756 45.8908 16.5 39.9998 16.5C34.1087 16.5 29.3331 21.2756 29.3331 27.1667C29.3331 33.0577 34.1087 37.8333 39.9998 37.8333ZM16.7364 59.2344C19.3741 49.9988 28.7893 43.1667 39.9998 43.1667C51.2102 43.1667 60.6255 49.9988 63.2631 59.2344C64.072 62.0666 61.612 64.5 58.6665 64.5H21.3331C18.3876 64.5 15.9275 62.0666 16.7364 59.2344Z",
    fill: "#3451D7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62.5,
    r: 10,
    fill: "#24C56E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5 62.5L61 65L65.5 60",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundUser);
export default __webpack_public_path__ + "static/media/found-user.97e51aac65e863e49304ca00d15861b9.svg";
export { ForwardRef as ReactComponent };